/* Note: This is an autogenerated file. Please DO NOT modify anything manually here. */
import * as Types from "src/generated/graph-api";

import { gql } from "@apollo/client";
import {
	AgentAccountProfileMemberFieldsFragmentDoc,
	AgentAccountProfileUserFieldsFragmentDoc,
} from "../../components/AgentAccountInformation/AgentAccountInformation.generated";
import { AccountSettingsHeaderFieldsFragmentDoc } from "../../components/AccountSettingsHeader/AccountSettingsHeader.generated";
import { AccountSettingsTeamMemberContactFormFieldsFragmentDoc } from "../../components/AccountSettingsTeamMemberForm/AccountSettingsTeamMemberContactForm.generated";
import { AccountSettingsBrokerageInfosFormFieldsFragmentDoc } from "../../components/AccountSettingsBrokerageInfosForm/AccountSettingsBrokerageInfosForm.generated";
import { AccountSettingsTeamDetailsFieldsFragmentDoc } from "../../components/AccountSettingsTeamDetails/AccountSettingsTeamDetails.generated";
import { DocumentDefaultsFieldsFragmentDoc } from "../../components/DocumentDefaults/DocumentDefaults.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GQLAgentAccountProfileUserQueryVariables = Types.Exact<{
	[key: string]: never;
}>;

export type GQLAgentAccountProfileUserQuery = {
	__typename: "Query";
	me: {
		__typename: "IdentityMePayload";
		record: {
			__typename: "IdentityUser";
			id: string;
			firstName: string | null;
			lastName: string | null;
			displayName: string | null;
			email: string | null;
			phoneNumber: string | null;
			personalEmail: string | null;
			photoUrl: string | null;
			agentTeam: { __typename: "IdentityTeam"; id: string } | null;
			teamMemberships: Array<{
				__typename: "IdentityTeamMember";
				id: string;
				status: Types.GQLIdentityTeamMemberStatus | null;
				email: string;
				team: {
					__typename: "IdentityTeam";
					name: string | null;
					status: Types.GQLIdentityTeamStatus;
					id: string;
					legalName: string | null;
					alias: string | null;
					logoUri: string | null;
					phoneNumber: string | null;
					email: string | null;
					websiteUrl: string | null;
					description: string | null;
					supervisingBroker: {
						__typename: "IdentityBroker";
						id: string;
						license: {
							__typename: "IdentityLicense";
							id: string;
							number: string | null;
							expiration: string | null;
							state: {
								__typename: "IdentitySupportedState";
								code: Types.GQLIdentitySupportedStateCode;
								name: string;
							} | null;
						} | null;
						user: {
							__typename: "IdentityBrokerUser";
							id: string;
							firstName: string | null;
							lastName: string | null;
						} | null;
					} | null;
					brokerage: {
						__typename: "IdentityBrokerage";
						name: string | null;
						id: string;
						licenseNumber: string | null;
						licenseExpiration: string | null;
						phoneNumber: string | null;
						address: {
							__typename: "IdentityAddress";
							city: string | null;
							id: string;
							postalCode: string | null;
							street1: string | null;
							street2: string | null;
							state: string | null;
						} | null;
						managingBroker: {
							__typename: "IdentityBroker";
							id: string;
							email: string | null;
							phoneNumber: string | null;
							user: {
								__typename: "IdentityBrokerUser";
								id: string;
								firstName: string | null;
								lastName: string | null;
								displayName: string | null;
							} | null;
							license: {
								__typename: "IdentityLicense";
								id: string;
								expiration: string | null;
								number: string | null;
								state: {
									__typename: "IdentitySupportedState";
									name: string;
									code: Types.GQLIdentitySupportedStateCode;
								} | null;
							} | null;
						} | null;
					} | null;
					mailingAddress: {
						__typename: "IdentityAddress";
						id: string;
						street1: string | null;
						street2: string | null;
						city: string | null;
						state: string | null;
						postalCode: string | null;
					} | null;
					registeredAddress: {
						__typename: "IdentityAddress";
						id: string;
						street1: string | null;
						street2: string | null;
						city: string | null;
						state: string | null;
						postalCode: string | null;
					} | null;
				};
				roles: Array<{
					__typename: "IdentityTeamMemberRole";
					code: Types.GQLIdentityTeamMemberRoleCode;
				}>;
				contacts: {
					__typename: "IdentityTeamMemberContacts";
					escrowOfficer: {
						__typename: "IdentityTeamMemberContact";
						id: string;
						role: string | null;
						firstName: string | null;
						lastName: string | null;
						cellPhone: string | null;
						email: string | null;
						companyName: string | null;
						address: {
							__typename: "IdentityAddress";
							street1: string | null;
							street2: string | null;
							city: string | null;
							state: string | null;
							postalCode: string | null;
						} | null;
					} | null;
					titleOfficer: {
						__typename: "IdentityTeamMemberContact";
						id: string;
						role: string | null;
						firstName: string | null;
						lastName: string | null;
						cellPhone: string | null;
						email: string | null;
						companyName: string | null;
						address: {
							__typename: "IdentityAddress";
							street1: string | null;
							street2: string | null;
							city: string | null;
							state: string | null;
							postalCode: string | null;
						} | null;
					} | null;
				} | null;
				user: {
					__typename: "IdentityUser";
					id: string;
					firstName: string | null;
					lastName: string | null;
					displayName: string | null;
					email: string | null;
					phoneNumber: string | null;
					personalEmail: string | null;
					address: {
						__typename: "IdentityAddress";
						street1: string | null;
						street2: string | null;
						city: string | null;
						state: string | null;
						postalCode: string | null;
						id: string;
					} | null;
					phoneNumbers: Array<{
						__typename: "IdentityContact";
						id: string;
						value: string;
						type: Types.GQLIdentityContactType | null;
						isPrimary: boolean;
					} | null> | null;
				};
				license: {
					__typename: "IdentityLicense";
					id: string;
					number: string | null;
				} | null;
				preferences: {
					__typename: "IdentityTeamMemberPreferences";
					sellingAgentCommission: string | null;
					listingPeriod: string | null;
					docusignCarbonCopy: Array<string>;
					agentCommission: string | null;
					mlsPreferences: Array<{
						__typename: "IdentityTeamMemberMlsPreference";
						primary: boolean;
						mls: {
							__typename: "MlsVendor";
							id: string;
							vendor: string;
							displayName: string;
						};
					}>;
				} | null;
			} | null> | null;
			address: {
				__typename: "IdentityAddress";
				street1: string | null;
				street2: string | null;
				city: string | null;
				state: string | null;
				postalCode: string | null;
				id: string;
			} | null;
			phoneNumbers: Array<{
				__typename: "IdentityContact";
				id: string;
				value: string;
				type: Types.GQLIdentityContactType | null;
				isPrimary: boolean;
			} | null> | null;
		} | null;
		error: { __typename: "IdentityMeError"; message: string } | null;
	};
};

export type GQLAgentAccountProfileTeamMemberRecordFragment = {
	__typename: "IdentityTeamMember";
	id: string;
	email: string;
	status: Types.GQLIdentityTeamMemberStatus | null;
	roles: Array<{
		__typename: "IdentityTeamMemberRole";
		code: Types.GQLIdentityTeamMemberRoleCode;
	}>;
	team: {
		__typename: "IdentityTeam";
		name: string | null;
		status: Types.GQLIdentityTeamStatus;
		id: string;
		legalName: string | null;
		alias: string | null;
		phoneNumber: string | null;
		email: string | null;
		logoUri: string | null;
		websiteUrl: string | null;
		description: string | null;
		supervisingBroker: {
			__typename: "IdentityBroker";
			id: string;
			license: {
				__typename: "IdentityLicense";
				id: string;
				number: string | null;
				expiration: string | null;
				state: {
					__typename: "IdentitySupportedState";
					code: Types.GQLIdentitySupportedStateCode;
					name: string;
				} | null;
			} | null;
			user: {
				__typename: "IdentityBrokerUser";
				id: string;
				firstName: string | null;
				lastName: string | null;
			} | null;
		} | null;
		brokerage: {
			__typename: "IdentityBrokerage";
			name: string | null;
			id: string;
			licenseNumber: string | null;
			licenseExpiration: string | null;
			phoneNumber: string | null;
			address: {
				__typename: "IdentityAddress";
				city: string | null;
				id: string;
				postalCode: string | null;
				street1: string | null;
				street2: string | null;
				state: string | null;
			} | null;
			managingBroker: {
				__typename: "IdentityBroker";
				id: string;
				email: string | null;
				phoneNumber: string | null;
				user: {
					__typename: "IdentityBrokerUser";
					id: string;
					firstName: string | null;
					lastName: string | null;
					displayName: string | null;
				} | null;
				license: {
					__typename: "IdentityLicense";
					id: string;
					expiration: string | null;
					number: string | null;
					state: {
						__typename: "IdentitySupportedState";
						name: string;
						code: Types.GQLIdentitySupportedStateCode;
					} | null;
				} | null;
			} | null;
		} | null;
		mailingAddress: {
			__typename: "IdentityAddress";
			id: string;
			street1: string | null;
			street2: string | null;
			city: string | null;
			state: string | null;
			postalCode: string | null;
		} | null;
		registeredAddress: {
			__typename: "IdentityAddress";
			id: string;
			street1: string | null;
			street2: string | null;
			city: string | null;
			state: string | null;
			postalCode: string | null;
		} | null;
	};
	contacts: {
		__typename: "IdentityTeamMemberContacts";
		escrowOfficer: {
			__typename: "IdentityTeamMemberContact";
			id: string;
			role: string | null;
			firstName: string | null;
			lastName: string | null;
			cellPhone: string | null;
			email: string | null;
			companyName: string | null;
			address: {
				__typename: "IdentityAddress";
				street1: string | null;
				street2: string | null;
				city: string | null;
				state: string | null;
				postalCode: string | null;
			} | null;
		} | null;
		titleOfficer: {
			__typename: "IdentityTeamMemberContact";
			id: string;
			role: string | null;
			firstName: string | null;
			lastName: string | null;
			cellPhone: string | null;
			email: string | null;
			companyName: string | null;
			address: {
				__typename: "IdentityAddress";
				street1: string | null;
				street2: string | null;
				city: string | null;
				state: string | null;
				postalCode: string | null;
			} | null;
		} | null;
	} | null;
	user: {
		__typename: "IdentityUser";
		id: string;
		firstName: string | null;
		lastName: string | null;
		displayName: string | null;
		email: string | null;
		phoneNumber: string | null;
		personalEmail: string | null;
		address: {
			__typename: "IdentityAddress";
			street1: string | null;
			street2: string | null;
			city: string | null;
			state: string | null;
			postalCode: string | null;
			id: string;
		} | null;
		phoneNumbers: Array<{
			__typename: "IdentityContact";
			id: string;
			value: string;
			type: Types.GQLIdentityContactType | null;
			isPrimary: boolean;
		} | null> | null;
	};
	license: {
		__typename: "IdentityLicense";
		id: string;
		number: string | null;
	} | null;
	preferences: {
		__typename: "IdentityTeamMemberPreferences";
		sellingAgentCommission: string | null;
		listingPeriod: string | null;
		docusignCarbonCopy: Array<string>;
		agentCommission: string | null;
		mlsPreferences: Array<{
			__typename: "IdentityTeamMemberMlsPreference";
			primary: boolean;
			mls: {
				__typename: "MlsVendor";
				id: string;
				vendor: string;
				displayName: string;
			};
		}>;
	} | null;
};

export const AgentAccountProfileTeamMemberRecordFragmentDoc = gql`
    fragment AgentAccountProfileTeamMemberRecord on IdentityTeamMember {
  id
  roles {
    code
  }
  email
  status
  ...AccountSettingsTeamMemberContactFormFields
  team {
    ...AccountSettingsBrokerageInfosFormFields
    ...AccountSettingsTeamDetailsFields
    name
    status
    supervisingBroker {
      id
      license {
        id
        number
        state {
          code
        }
      }
    }
  }
  ...AgentAccountProfileMemberFields
  ...DocumentDefaultsFields
}
    ${AccountSettingsTeamMemberContactFormFieldsFragmentDoc}
${AccountSettingsBrokerageInfosFormFieldsFragmentDoc}
${AccountSettingsTeamDetailsFieldsFragmentDoc}
${AgentAccountProfileMemberFieldsFragmentDoc}
${DocumentDefaultsFieldsFragmentDoc}`;
export const AgentAccountProfileUserDocument = gql`
    query AgentAccountProfileUser {
  me {
    record {
      id
      ...AgentAccountProfileUserFields
      ...AccountSettingsHeaderFields
      agentTeam {
        id
      }
      teamMemberships {
        ...AgentAccountProfileTeamMemberRecord
      }
    }
    error {
      message
    }
  }
}
    ${AgentAccountProfileUserFieldsFragmentDoc}
${AccountSettingsHeaderFieldsFragmentDoc}
${AgentAccountProfileTeamMemberRecordFragmentDoc}`;

/**
 * __useAgentAccountProfileUserQuery__
 *
 * To run a query within a React component, call `useAgentAccountProfileUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentAccountProfileUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentAccountProfileUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentAccountProfileUserQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GQLAgentAccountProfileUserQuery,
		GQLAgentAccountProfileUserQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GQLAgentAccountProfileUserQuery,
		GQLAgentAccountProfileUserQueryVariables
	>(AgentAccountProfileUserDocument, options);
}
export function useAgentAccountProfileUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GQLAgentAccountProfileUserQuery,
		GQLAgentAccountProfileUserQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GQLAgentAccountProfileUserQuery,
		GQLAgentAccountProfileUserQueryVariables
	>(AgentAccountProfileUserDocument, options);
}
// @ts-ignore
export function useAgentAccountProfileUserSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GQLAgentAccountProfileUserQuery,
		GQLAgentAccountProfileUserQueryVariables
	>,
): Apollo.UseSuspenseQueryResult<
	GQLAgentAccountProfileUserQuery,
	GQLAgentAccountProfileUserQueryVariables
>;
export function useAgentAccountProfileUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GQLAgentAccountProfileUserQuery,
				GQLAgentAccountProfileUserQueryVariables
		  >,
): Apollo.UseSuspenseQueryResult<
	GQLAgentAccountProfileUserQuery | undefined,
	GQLAgentAccountProfileUserQueryVariables
>;
export function useAgentAccountProfileUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GQLAgentAccountProfileUserQuery,
				GQLAgentAccountProfileUserQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GQLAgentAccountProfileUserQuery,
		GQLAgentAccountProfileUserQueryVariables
	>(AgentAccountProfileUserDocument, options);
}
export type AgentAccountProfileUserQueryHookResult = ReturnType<
	typeof useAgentAccountProfileUserQuery
>;
export type AgentAccountProfileUserLazyQueryHookResult = ReturnType<
	typeof useAgentAccountProfileUserLazyQuery
>;
export type AgentAccountProfileUserSuspenseQueryHookResult = ReturnType<
	typeof useAgentAccountProfileUserSuspenseQuery
>;
export type AgentAccountProfileUserQueryResult = Apollo.QueryResult<
	GQLAgentAccountProfileUserQuery,
	GQLAgentAccountProfileUserQueryVariables
>;
